import { useNavigate } from "react-router-dom";

import { Link } from "@/components/atoms/Link";
import { Logo } from "@/components/atoms/Logo";
import { FieldEnum } from "@/components/organisms/Field/FieldEnum";
import { Typography as UITypography } from "@/components/ui/typography";
import { Navigation, Values } from "@/constants";

function Typography(props: React.ComponentProps<typeof UITypography>) {
  return <UITypography style={{ color: "oklch(0.985 0 0)" }} {...props} />;
}

export function PublicFooterLayout() {
  const navigate = useNavigate();

  return (
    <div className="flex-col items-start w-full pt-8 pl-0 pr-0 relative">
      <div className="pt-8 w-full">
        <div className="grid gap-8 md:grid-cols-[repeat(3,1fr)] xl:grid-cols-[repeat(5,1fr)]">
          <div className="flex-col justify-between items-baseline mb-8">
            <div className="flex-col">
              <div
                onClick={() => navigate(Navigation.ROUTES.PAGE)}
                className="mb-[10.4px] [margin-top:-3.2px]"
              >
                <Logo variant="logo-with-text" color={"white"} />
              </div>
              {Navigation.FOOTER_FOOTNOTES.map((item) => (
                <div key={item.name} className="mt-1">
                  <Link
                    href={item.path}
                    level="body-md"
                    color={
                      "color-mix(in oklab, oklch(0.708 0 0) 80%, transparent)"
                    }
                  >
                    {item.name}
                  </Link>
                </div>
              ))}
            </div>
          </div>
          {Navigation.FOOTER_SECTIONS.map((item) => (
            <div key={item.name} className="w-full">
              <div className="flex-col items-start">
                <div className="mb-4">
                  <Typography level="body-lg">{item.name}</Typography>
                </div>
                {item.items.map((subitem) => (
                  <div
                    key={subitem.name}
                    className="mt-1 relative flex items-baseline"
                  >
                    <Link
                      href={subitem.path}
                      level="body-md"
                      color={"oklch(0.708 0 0)"}
                    >
                      {subitem.name}
                    </Link>
                    {subitem?.state && (
                      <FieldEnum value={subitem.state} isMultiline={false} />
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="pt-4 pb-8 mt-16 w-full flex justify-start">
        <Typography level="body-md" className="inline">
          ©{new Date().getFullYear()} {Values.COMPANY_NAME}, all rights
          reserved.&nbsp;
        </Typography>
      </div>
    </div>
  );
}
